import {
  initialReportAvgPriceState,
  initialReportBestItemsState,
  initialReportFillRateState,
  initialReportKeyIndicatorsState, initialReportKeyIndicatorsSuppliersState,
  initialReportMarketShareState,
  initialReportProfitabilityState,
  initialReportPromoState, initialReportServiceLevelState,
  initialReportStockRotationState,
  IReportAvgPriceState,
  IReportBestItemsState,
  IReportFillRateState,
  IReportKeyIndicatorsState, IReportKeyIndicatorsSuppliersState,
  IReportMarketShareState,
  IReportProfitabilityState,
  IReportPromoState, IReportServiceLevelState,
  IReportStockRotationState
} from "./reports-insights.state";
import {initialReportComparativeNomenclatureState, initialReportComparativeStoresState, initialReportDynamicsState, initialReportTotalState, IReportComparativeNomenclatureState, IReportComparativeStoresState, IReportDynamicsState, IReportTotalState} from "./reports-performance.state";

export interface IReportsInsightsState {
  reportFillRate: IReportFillRateState;
  reportStockRotation: IReportStockRotationState;
  reportMarketShare: IReportMarketShareState;
  reportKeyIndicators: IReportKeyIndicatorsState;
  reportProfitability: IReportProfitabilityState;
  reportPromo: IReportPromoState;
  reportKeyIndicatorsSuppliers: IReportKeyIndicatorsSuppliersState;
  reportBestItems: IReportBestItemsState;
  reportAvgPrice:IReportAvgPriceState;
  reportServiceLevel: IReportServiceLevelState;
}
export interface IReportsPerformanceState {
  reportTotal: IReportTotalState;
  reportComparativeStores: IReportComparativeStoresState;
  reportComparativeNomenclature: IReportComparativeNomenclatureState;
  reportDynamics: IReportDynamicsState;
}
//---------------------------
export const initialReportsPerformanceState: IReportsPerformanceState = {
  reportTotal: initialReportTotalState,
  reportComparativeStores: initialReportComparativeStoresState,
  reportComparativeNomenclature: initialReportComparativeNomenclatureState,
  reportDynamics: initialReportDynamicsState
}
export const initialReportsInsightsState:IReportsInsightsState = {
  reportFillRate:initialReportFillRateState,
  reportStockRotation: initialReportStockRotationState,
  reportMarketShare: initialReportMarketShareState,
  reportKeyIndicators: initialReportKeyIndicatorsState,
  reportProfitability: initialReportProfitabilityState,
  reportPromo: initialReportPromoState,
  reportKeyIndicatorsSuppliers: initialReportKeyIndicatorsSuppliersState,
  reportBestItems: initialReportBestItemsState,
  reportAvgPrice:initialReportAvgPriceState,
  reportServiceLevel: initialReportServiceLevelState
};
//---------------
export interface IReportsDataState {
  insights: IReportsInsightsState;
  performance: IReportsPerformanceState;
 }
export const initialReportsDataState: IReportsDataState = {
  insights: initialReportsInsightsState,
  performance: initialReportsPerformanceState

};
